import { RuleObject } from "antd/es/form";
import { t } from "i18next";

export const checkTemp = (
  _: RuleObject,
  value: number,
) => {
  const min = 20;
  const max = 40;
  const valueNumber = value ? Number.parseInt(value.toString()) : value;

  if (!valueNumber) {
    return Promise.reject(new Error("Temperature is required"));
  }
  if (valueNumber <= min)
    return Promise.reject(
      new Error(`${t("Sell-Transport:transport.error.temperature_less")}`),
    );
  if (valueNumber > max)
    return Promise.reject(
      new Error(`${t("Sell-Transport:transport.error.temperature_notexceed")}`),
    );
  if (valueNumber && valueNumber > min && valueNumber <= max) {
    return Promise.resolve();
  }
};
